import {
  SettingCreateBody,
  SettingListResponse,
  SettingItem,
  SettingDetailResponse,
} from "utils/api/client/types"

export class Setting {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: SettingCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: SettingItem }> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/settings`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(
    vendorId: string,
    body: SettingCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SettingItem> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/settings`, {
        method: "PUT",
        headers,
        body,
        query,
      })
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SettingListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/settings`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SettingDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/settings/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/settings/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
